<button
  class="btn btn-sm page-link text-dark d-inline-block"
  (click)="download()"
>
  Request
</button>

<alert type="info" *ngIf="status == 'progress'"> waiting... </alert>
<alert type="success" *ngIf="status == 'done'"> success!! </alert>
<alert type="danger" *ngIf="status == 'fail'"> fail </alert>
